module.exports = __webpack_public_path__ + "img/image6.14f93926.jpeg";